enum InvoiceStatus {
  Requested = "REQUESTED",
  Pending = "PENDING",
  Approved = "APPROVED",
  Declined = "DECLINED"
}

export default InvoiceStatus